import { useMutation } from "@apollo/client";
import { DeepPartial, useForm } from "react-hook-form";

import { CREATE_ORDER } from "../order.queries";
import { parseParams } from "../../../helpers/clean-object";

import { CreateOrderInput } from "../../../__generated__/globalTypes";
import {
  CreateOrderMutation,
  CreateOrderMutationVariables,
} from "../../../__generated__/CreateOrderMutation";

interface IProps {
  defaultValues: DeepPartial<CreateOrderInput>;
  onCompleted: (id?: number | null) => any;
}

export const useCreateOrder = ({ defaultValues, onCompleted }: IProps) => {
  const form = useForm<CreateOrderInput>({
    mode: "all",
    defaultValues,
  });
  const [mutate, { loading }] = useMutation<
    CreateOrderMutation,
    CreateOrderMutationVariables
  >(CREATE_ORDER, {
    refetchQueries: ["OrdersQuery"],
  });

  const submit = async () => {
    if (loading) return;
    try {
      const input = form.getValues();
      const { data } = await mutate({
        variables: {
          input: parseParams(input),
        },
      });

      if (data?.createOrder?.ok) {
        onCompleted(data.createOrder.id);
      } else {
        throw Error(data?.createOrder?.error ?? "Error");
      }
    } catch (error) {
      console.log(error);
    }
  };
  return {
    form,
    mutate,
    loading,
    submit,
  };
};
